import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { SurveyAlertDto } from '../types';

export const getAlertSurveyById = async (surveyImportResultId: number): Promise<SurveyAlertDto> => {
	const response = await fetchApi.get(`/alert/survey/${surveyImportResultId}`) as SurveyAlertDto;
  	return response;
}

type QueryFnType = typeof getAlertSurveyById;

type UseSurveyOptions = {
  surveyId: number | null; 
  config?: QueryConfig<QueryFnType>;
};

export const useAlertSurvey = ({ surveyId, config = {} }: UseSurveyOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['alertSurvey', surveyId],
        queryFn: () => getAlertSurveyById(surveyId!), // el "!" es seguro porque solo se ejecuta si enabled es true
        enabled: !!surveyId,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};